module.exports = __webpack_public_path__ + "img/fouth-app-title.062014ab.png";